import api from '@/shared/api/token'

const ENDPOINT = '/introducers'

/*
 * Schedule 1 of the Introducer Agreement.
 *
 * `preview` and `get` are deliberately NOT interchangeable and must never be collapsed
 * into one call with a flag. `preview` is admin-only and writes nothing -- it renders
 * rows that have not been listed. `get` returns the real Schedule, and under clause 6.10
 * that display counts as written notification to the Introducer. Calling the wrong one is
 * a contractual error, not a display bug, so they stay two named methods.
 */
class SchedulesService {
  preview(introducerId) {
    return api.get(ENDPOINT + '/' + introducerId + '/schedule/preview').then((response) => {
      return response.data.data
    })
  }

  get(introducerId) {
    return api.get(ENDPOINT + '/' + introducerId + '/schedule').then((response) => {
      return response.data.data
    })
  }

  /* Listing is a deliberate, per-client act; the write is the notification. */
  list(introducerId, clientId, basis) {
    return api.post(ENDPOINT + '/' + introducerId + '/schedule', {
      client: clientId,
      basis
    }).then((response) => {
      return response.data.data
    })
  }

  /* Delisting is deliberate and reasoned: the reason and the naming of the authorising
     limb are both mandatory server-side, and the row survives carrying them. */
  remove(entryId, reason, basis) {
    return api.put('/schedule-entries/' + entryId + '/remove', {
      reason,
      basis
    }).then((response) => {
      return response.data.data
    })
  }
}

export default new SchedulesService()
